import { call, put, takeEvery } from "redux-saga/effects";
import { heSoUuTienTKBApi } from "../../../api/category/heSoUuTienTKBApi";
import { IHeSoUuTienTKB } from "../../../model/respone/category/IHeSoUuTienTKB";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eHeSoUuTienTKBActionIds,
  IHeSoUuTienTKBActionTypes,
} from "../../action-types/category/IHeSoUuTienTKBActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.heSoUuTienTKB;

export function* heSoUuTienTKBSaga(): any {
  yield takeEvery(eHeSoUuTienTKBActionIds.LOAD_START, loadWorker);
  yield takeEvery(eHeSoUuTienTKBActionIds.SAVE_START, saveWorker);
}
function* loadWorker(): any {
  const res: IBaseRespone = yield call(heSoUuTienTKBApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}
function* saveWorker(action: IHeSoUuTienTKBActionTypes): any {
  const payload = action.payload as IHeSoUuTienTKB;
  // 17 hệ số là seed-locked, không có flow Insert — chỉ Update qua API.
  const res: IBaseRespone = yield call(heSoUuTienTKBApi.Update, payload);
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}
